import React from 'react'

export default function ViewTask() {
  return (
    <div>MAP</div>
  )
}
